<template>    
    <BaseModal
        :id="'static-reset-password'"
        :message="''"
        :size="'sm'"
    >

        <template v-slot:content>
            <div class="text-center mb-4">
                <img  src="assets/img/logo.png" class="d-block mx-auto pt-md-0" alt="logo" style="padding-bottom: 0px; width: 125px;"/>
                <b class="d-block mx-auto mt-3" style="font-size: 1rem;">Find your Digital Solutions account</b>
            </div>

            <form class="p-0" @submit.prevent="form_submit_local()">
                <div class="row" style="padding:  0 15% 0 15%">
                    <div class="login__input first w-100 mt-3 mb-0">
                        <img src="assets/img/us.png" alt="Icon us" class="login__input__icon">
                        <label for="email" class="login__input__label">Email: <b style="color:red;">*</b></label>
                        <input
                            id="email"
                            type="email"
                            v-model="form_data.email"
                            class="login__input__field"
                            required
                        />
                    </div>

                <div class="col-md-12 pl-0 pt-1">Requires your primary account email address.</div>
                <div class="w-100 mt-3">
                    <vue-recaptcha 
                    :sitekey="sitekey"
                    type="checkbox"
                    :load-recaptcha-script="true"
                    @verify="handleSuccess"
                    @expired="handleExpired"
                    @error="handleError" 
                    ref="recaptcha"
                    />
                </div>
                </div>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button :disabled="disabled" :class="disabled ? 'disabled_button' : ''" class="modal__buttons__item" v-html="`Reset password`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<script>

// import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import Resources            from './Resources'
import FormResources        from './form_resources'
import { VueRecaptcha } from 'vue-recaptcha';

export default {

    name:   'ResetPasswordModal',

    props: [
    ],

    components:{
        // Breadcrumb,
        BaseModal,
        VueRecaptcha,
        
    },

    data(){
        return{
            breadcrumb: Resources.breadcrumb_reset_password,
            form_format: FormResources.form_format,
            form_data: FormResources.form_data,
            form_backup: {...FormResources.form_data},
            disabled: true,
            sitekey: '6LfRH1ojAAAAAA4mHegqAJADdDa6wEUvYeT9VyNX'
        }
    },

    mounted()
    {
    },

    methods:{
        async form_submit_local()
        {
            this.loader(true)
            window.$('#static-reset-password').modal('hide')
            this.disabled = true
            const response = await this.post('auth/forgot-password', {...this.form_data, version: 'web'}, {}, false);

            if(response.status)
            {
                this.form_data = {...this.form_backup};
                this.notyfMesg('Check your email for further steps')
            }
            else
            {
                window.$('#static-reset-password').modal('show')
                this.error_handling(response)
            }
            this.loader(false)
            this.handleExpired()
        },
        handleSuccess(recaptchaToken){
            this.disabled = false
            this.form_data.recaptcha = recaptchaToken
        },
        handleError() {
            this.error_handling('error when validating recaptcha')
        },
        handleExpired()
        {
            this.$refs.recaptcha.reset();
            this.form_data.recaptcha = null
            this.disabled = true
        }

    },

    
}
</script>